import React, { useContext } from "react";
import BundleContext from "../Contexts/BundleContext";
import { IComponent } from "../Models/IComponent";
import ButtonComponent from "./Button/ButtonComponent";
import ButtonGroupComponent from "./ButtonGroup/ButtonGroupComponent";
import ChatComponent from "./Chat/ChatComponent";
import ChipComponent from "./Chip/ChipComponent";
import BarChartComponent from "./Dashboards/BarChartComponent";
import PieChartComponent from "./Dashboards/PieChartComponent";
import ValueCounterComponent from "./Dashboards/ValueCounterComponent";
import DataDisplayComponent from "./DataDisplay/DataDisplayComponent";
import FileTableComponent from "./FileTable/FileTableComponent";
import GridContainerComponent from "./GridContainer/GridContainerComponent";
import IComponentProps from "./IComponentProps";
import ImageComponent from "./Image/ImageComponent";
import InputCheckboxComponent from "./InputCheckbox/InputCheckboxComponent";
import InputFieldComponent from "./InputField/InputFieldComponent";
import InputSelectComponent from "./InputSelect/InputSelectComponent";
import LinkComponent from "./Link/LinkComponent";
import ListComponent from "./List/ListComponent";
import MapDisplayComponent from "./MapDisplay/MapDisplayComponent";
import PanelComponent from "./Panel/PanelComponent";
import RepeatContainerComponent from "./RepeatContainer/RepeatContainerComponent";
import StackContainerComponent from "./StackContainer/StackContainerComponent";
import TableComponent from "./Table/TableComponent";
import TabsComponent from "./Tabs/TabsComponent";
import TypographyComponent from "./Typography/TypographyComponent";
import ViewBreadcrumbsComponent from "./ViewBreadcrumbs/ViewBreadcrumbsComponent";
import WebViewComponent from "./WebView/WebViewComponent";

type ComponentFactoryProps = IComponentProps<IComponent>;

const ComponentFactory: React.FC<ComponentFactoryProps> = ({ parent, component, context }) => {
  const typedComponent = component as any;

  const bundle = useContext(BundleContext);

  switch (component.Type) {
    case "Typography":
      return <TypographyComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "Button":
      return <ButtonComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "ButtonGroup":
      return <ButtonGroupComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "Chat":
      return <ChatComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "DataDisplay":
      return <DataDisplayComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "FileTable":
      return <FileTableComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "List":
      return <ListComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "Link":
      return <LinkComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "MapDisplay":
      return <MapDisplayComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "Table":
      return <TableComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "GridContainer":
      return <GridContainerComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "Image":
      return <ImageComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "InputCheckbox":
      return <InputCheckboxComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "InputField":
      return <InputFieldComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "InputSelect":
      return <InputSelectComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "Panel":
      return <PanelComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "Chip":
      return <ChipComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "RepeatContainer":
      return <RepeatContainerComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "StackContainer":
      return <StackContainerComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "Tabs":
      return <TabsComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "ValueCounter":
      return <ValueCounterComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "PieChart":
      return <PieChartComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "BarChart":
      return <BarChartComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "ViewBreadcrumbs":
      return <ViewBreadcrumbsComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "WebView":
      return <WebViewComponent key={component.Id} parent={parent} component={typedComponent} context={context} />;
    case "Reference":
      const sharedComponent = bundle.SharedComponentById[typedComponent.ComponentId];
      if (!sharedComponent) {
        return <div>Shared component not found: {typedComponent.ComponentId}</div>;
      }
      return <ComponentFactory key={sharedComponent.Component.Id} parent={parent} component={sharedComponent.Component} context={context} />;
    default:
      console.warn(`Unknown component type: ${component.Type}`);
      return (
        <div>
          Unknown component type: {component.Type} (ID: {component.Id})
        </div>
      );
  }
};

export default ComponentFactory;
